/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentDto } from '../../models/consultation-content-dto';

export interface ConsultationContentAdminControllerFindAllV1$Params {

/**
 * 콘텐츠 유형
 */
  type?: 'PREORDER' | 'PROMOTION';
}

export function consultationContentAdminControllerFindAllV1(http: HttpClient, rootUrl: string, params?: ConsultationContentAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConsultationContentDto>>> {
  const rb = new RequestBuilder(rootUrl, consultationContentAdminControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConsultationContentDto>>;
    })
  );
}

consultationContentAdminControllerFindAllV1.PATH = '/api/v1/consultation-contents/admin';
